/* SOO Ceylon - Highland Luxe interactions
   - Sticky add-to-cart bar on product pages (low-friction conversion)
*/
(function () {
  function initStickyATC() {
    var isProduct = /\/products\//.test(window.location.pathname);
    if (!isProduct) return;

    var addBtn = document.querySelector('.product-form__submit') ||
      document.querySelector('button[name="add"]');
    if (!addBtn) return;

    var titleEl = document.querySelector('.product__title h1') ||
      document.querySelector('.product__title') ||
      document.querySelector('h1');
    var title = titleEl ? titleEl.textContent.trim() : '';
    if (!title) return;

    var imgEl = document.querySelector('.product__media img') ||
      document.querySelector('.product__media-item img');
    var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

    function getPrice() {
      var p = document.querySelector('.price__container .price-item--regular') ||
        document.querySelector('.price .price-item--regular') ||
        document.querySelector('.price-item--regular') ||
        document.querySelector('.price__sale .price-item--sale');
      return p ? p.textContent.trim() : '';
    }

    var bar = document.createElement('div');
    bar.className = 'soo-sticky-atc';
    var html = '<div class="soo-sticky-atc__inner"><div class="soo-sticky-atc__meta">';
    if (imgSrc) html += '<img class="soo-sticky-atc__img" src="' + imgSrc + '" alt="" loading="lazy">';
    html += '<span class="soo-sticky-atc__title">' + title + '</span>';
    html += '<span class="soo-sticky-atc__price">' + getPrice() + '</span>';
    html += '</div><button type="button" class="soo-sticky-atc__btn">Add to Cart</button></div>';
    bar.innerHTML = html;
    document.body.appendChild(bar);

    var priceTarget = bar.querySelector('.soo-sticky-atc__price');
    var stickyBtn = bar.querySelector('.soo-sticky-atc__btn');

    stickyBtn.addEventListener('click', function () {
      priceTarget.textContent = getPrice();
      addBtn.click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    document.addEventListener('change', function (ev) {
      if (ev.target.closest('product-form, variant-radios, variant-selects, .product-form')) {
        setTimeout(function () { priceTarget.textContent = getPrice(); }, 350);
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            bar.classList.remove('is-visible');
          } else if (e.boundingClientRect.top < 0) {
            priceTarget.textContent = getPrice();
            bar.classList.add('is-visible');
          }
        });
      }, { threshold: 0 });
      io.observe(addBtn);
    }
  }

  /* Currency transparency: display currency is a convenience conversion,
     orders are charged in MYR at checkout. Keep buyers informed before checkout. */
  function injectCurrencyNote() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    function addNote() {
      var footer = drawer.querySelector('.drawer__footer');
      if (!footer || footer.querySelector('.soo-currency-note')) return;
      var note = document.createElement('p');
      note.className = 'soo-currency-note';
      note.textContent = 'Prices shown in other currencies are a guide - your order is securely charged in Malaysian Ringgit (MYR).';
      footer.appendChild(note);
    }
    addNote();
    new MutationObserver(addNote).observe(drawer, { childList: true, subtree: true });
  }

  function initAll() {
    initStickyATC();
    injectCurrencyNote();
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
